export default function SizeSelector({ sizes, selected, onChange }) {
  return (
    <div>
      <p className="mb-3 text-sm font-medium">Size</p>
      <div className="grid grid-cols-4 gap-2" role="radiogroup" aria-label="Select size">
        {sizes.map((size) => (
          <button
            key={size}
            type="button"
            onClick={() => onChange(size)}
            className={`rounded-full border px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring ${
              selected === size
                ? "border-foreground bg-foreground text-background"
                : "border-border bg-white"
            }`}
          >
            {size}
          </button>
        ))}
      </div>
    </div>
  );
}